import { useState } from "react";
import styled from "styled-components";
import Pin1 from "../assets/images/pin1.svg";
import Pin2 from "../assets/images/pin2.svg";
import {  Link } from "@reach/router";
import { t } from "../lang";
import Line1 from "../assets/images/line1.svg";

const IndustryCitySelect = (props: any) => {
  const data = {
    items: [
      {
        id: "city1",
        title: "city1",
        icon: Pin1,
      },
      {
        id: "city2",
        title: "city2",
        icon: Pin1,
      },
      {
        id: "city3",
        title: "city3",
        icon: Pin1,
      },
    ],
  };

  const [state, setstate] = useState(data);
  return (
    <Container className="Container">
      <Title className="Title">{t('Select Industry City')}</Title>
      <Content className="Content">
        {state.items.map((item) => (
          <Link to={`/location_picker`}>
            <Item key={item.id} className="Item" onClick={()=>{
              localStorage.setItem('industryCity', item.id);
            }}>
              <ItemIcon className="ItemIcon" src={item.icon} />
              <ItemTitle className="ItemTitle">{t(item.title)}</ItemTitle>
            </Item>
          </Link>
        ))}
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${Line1});
background-repeat-y: no-repeat;
// background-position: center;
background-size: cover;
`;

const Content = styled.div`

`;
const Item = styled.div`
  display: flex;
  justify-content: space-between;
    align-items: center;
  cursor: pointer;
  min-width: 255px;
  border-radius: 10px;
  padding: 0px 20px;
  background: #2091af;    margin-bottom: 10px;
  &:hover {
    background: #182933;
  }
`;

const Title = styled.h1`
font-size: 2.5em;
color:#182a33;
position: relative;
::before {
  border-top: 23px solid rgb(251 224 104);
  content: "";
  position: absolute;
  inset: 37px 0px 0px;
  width: 81%;
  z-index: -1;
}
`;
const ItemTitle = styled.h2`
font-size: 1.3em;

`;
const ItemIcon = styled.img`
  height: 40px;
  margin: 0px 10px;
`;

export default IndustryCitySelect;
